import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from '../../ui/common';

/**
 * Pusty stan listy: jeden blok zamiast kilku zbudowanych osobno.
 *
 * Puste stany istnialy dotad tylko na czesci list (magazyn, klienci, kalendarz) i kazdy byl
 * skladany od zera na swojej stronie, wiec ta sama sytuacja ("nie masz jeszcze zadnych danych")
 * wygladala na kazdym ekranie inaczej, a na pozostalych listach uzytkownik dostawal pusta tabele
 * bez zadnej podpowiedzi, co dalej.
 *
 * DLACZEGO BEZ WLASNEGO TLA I RAMKI: ten blok lezy juz WEWNATRZ karty strony. Wlasne tlo zrobiloby
 * z niego druga karte w karcie — dokladnie ten efekt "pudelko w pudelku", ktory sprawia, ze ekrany
 * wygladaja na sklejone z roznych aplikacji.
 *
 * DLACZEGO NIE WLASNE PRZYCISKI: `PrimaryButton`/`SecondaryButton` z `ui/common.js` juz istnieja i
 * niosa tokeny. Kolejna lokalna kopia przycisku glownego byla by dwunasta w projekcie.
 */

/* Wariant z `to` (nawigacja) MUSI byc znacznikiem `a`, a nie `button` w `a` — zagniezdzenie jest
   niepoprawne w HTML i psuje obsluge klawiatura. Zamiast pisac drugi, blizniaczy zestaw stylow,
   podmieniamy sam znacznik przez `as={Link}`: styl (a wiec i tokeny) zostaje DOKLADNIE ten sam,
   dochodzi tylko zdjecie podkreslenia, ktore `a` ma z globalnych stylow. */
const PrimaryAction = styled(PrimaryButton)`
  text-decoration: none;
`;

const SecondaryAction = styled(SecondaryButton)`
  text-decoration: none;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${(p) => (p.$compact ? 'var(--sp-5) var(--sp-4)' : 'var(--sp-8) var(--sp-4)')};
`;

const IconSlot = styled.div`
  /* Ikona jest tu tlem dla tresci, nie trescia — stad kolor wyciszony. Rozmiar narzucamy CSS-em,
     zeby wywolujacy podawal samo <PackageIcon /> i nie musial pamietac o propie size. */
  color: var(--text-muted);
  line-height: 0;
  margin-bottom: var(--sp-3);

  svg {
    width: ${(p) => (p.$compact ? '28px' : '40px')};
    height: ${(p) => (p.$compact ? '28px' : '40px')};
  }
`;

const Title = styled.div`
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--text);
`;

const Description = styled.p`
  margin: var(--sp-2) 0 0;
  font-size: var(--fs-base);
  color: var(--text-muted);
  /* Wiersz dluzszy niz mniej wiecej 60 znakow czyta sie zle, a wysrodkowany tekst jeszcze gorzej. */
  max-width: 52ch;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--sp-2);
  margin-top: ${(p) => (p.$compact ? 'var(--sp-4)' : 'var(--sp-5)')};

  /* Oba przyciski z ui/common.js rozciagaja sie do 100% szerokosci na telefonie, wiec bez
     kolumny drugi z nich wyladowalby w osobnym wierszu, ale z resztka odstepu obok. */
  @media (max-width: 768px) {
    flex-direction: column;
    align-self: stretch;
  }
`;

/** Jedna akcja: `{ label, to }` prowadzi gdzies w aplikacji, `{ label, onClick }` cos robi na miejscu. */
function Action({ config, as: Button }) {
  if (!config || !config.label) return null;

  if (config.to) {
    return (
      <Button as={Link} to={config.to}>
        {config.label}
      </Button>
    );
  }

  return (
    <Button type="button" onClick={config.onClick}>
      {config.label}
    </Button>
  );
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
  compact,
  'data-cy': dataCy,
}) {
  const hasActions = !!(action && action.label) || !!(secondaryAction && secondaryAction.label);

  return (
    <Wrap $compact={!!compact} data-cy={dataCy}>
      {icon ? <IconSlot $compact={!!compact}>{icon}</IconSlot> : null}
      {title ? <Title>{title}</Title> : null}
      {description ? <Description>{description}</Description> : null}

      {hasActions ? (
        <Actions $compact={!!compact}>
          <Action config={action} as={PrimaryAction} />
          <Action config={secondaryAction} as={SecondaryAction} />
        </Actions>
      ) : null}
    </Wrap>
  );
}

export default EmptyState;
